<template>
  <div v-if="colorValues.length > 0" class="spangle-color-selector">
    <div class="spangle-color-selector__header">Select spangles colors</div>
    <div class="spangle-color-selector__color-container">
      <div
        v-for="(color, index) in colorValues"
        :key="color.value"
        class="spangle-color-selector__color"
      >
        <span class="spangle-color-selector__color-number">Color #{{ index + 1 }}</span>
        <Select
          :disabled="disabled"
          :value="getColorValue(color)"
          :options="colorOptions"
          :placeholder="'Select a color'"
          @on-change="selectColor(index, $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "pinia";
import Select from "./common/Select.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";

export default {
  name: "DtfSpanglesColorSelector",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Select
  },
  computed: {
    ...mapState(useDtfStore, ["spangleColors"]),
    ...mapState(useSpanglesStore, ["selectedVersion", "allAPIsCompleted"]),
    disabled() {
      return (
        !this.selectedVersion ||
        this.selectedVersion?.isLoading ||
        this.selectedVersion?.error ||
        !this.allAPIsCompleted
      );
    },
    colorOptions() {
      return this.spangleColors.map(color => ({
        value: `[${color.rgbCode}]`,
        label: color.name,
        prefix: color.imageUrl,
        labelSuffix: color.spangleCode
      }));
    },
    colorValues() {
      if (this.disabled) {
        return [];
      }

      return Object.values(this.selectedVersion.spanglePagesInfo).filter(
        color => typeof color === "object"
      );
    }
  },
  methods: {
    ...mapActions(useSpanglesStore, ["changeColor"]),
    getColorValue({ color }) {
      return this.colorOptions.find(colorValue => colorValue.value === JSON.stringify(color));
    },
    selectColor(index, color) {
      this.colorValues[index] = {
        ...this.colorValues[index],
        color: JSON.parse(color)
      };
      this.changeColor({
        colorValues: this.colorValues.reduce(
          (acc, value, trayIndex) => ({
            ...acc,
            [`tray_${trayIndex}`]: value
          }),
          {}
        )
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.spangle-color-selector {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;

  &__header {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }

  &__color {
    display: flex;
    flex-direction: column;
    width: 49%;
    margin-bottom: 10px;

    @include only-mobile {
      width: 100%;
    }
  }

  &__color-number {
    font-family: $font-family-primary;
    font-size: 14px;
    font-weight: 400;
    line-height: 13.8px;
    text-align: left;
    color: $gray-body;
    margin-bottom: 6px;
  }

  &__color-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    gap: 2%;

    @include only-mobile {
      gap: 0;
    }
  }

  .select {
    font-size: 12px;

    &__selector {
      border: 1px solid $gray-label;
    }
  }
}
</style>
